import script from "./SubmitCommentButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubmitCommentButton.vue?vue&type=script&lang=js"
export * from "./SubmitCommentButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubmitCommentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/comments-widget/SubmitCommentButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "423d94cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('423d94cc', __exports__)) {
    api.reload('423d94cc', __exports__)
  }
  
}


export default __exports__